import { render, staticRenderFns } from "./cardTemplateVip10.vue?vue&type=template&id=84714488&scoped=true&"
import script from "./cardTemplateVip10.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip10.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip10.vue?vue&type=style&index=0&id=84714488&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84714488",
  null
  
)

export default component.exports